var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplementaryPensionSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2129_70)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7165 35.6197C37.0767 35.6197 36.5282 35.3946 36.0712 34.9446C35.6141 34.4946 35.3891 33.9462 35.3962 33.2993C35.3891 32.6664 35.6141 32.125 36.0712 31.675C36.5282 31.225 37.0767 31 37.7165 31C38.3353 31 38.8732 31.225 39.3302 31.675C39.7943 32.125 40.0299 32.6664 40.0369 33.2993C40.0299 33.7282 39.9174 34.1184 39.6994 34.47C39.4885 34.8216 39.2072 35.1028 38.8556 35.3138C38.5111 35.5177 38.1314 35.6197 37.7165 35.6197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8678 13C33.4201 13 33.8678 13.4477 33.8678 14V34.9241C33.8678 35.4764 33.4201 35.9241 32.8678 35.9241H30.283C29.7307 35.9241 29.283 35.4764 29.283 34.9241V14C29.283 13.4477 29.7307 13 30.283 13H32.8678Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2259 13C25.7782 13 26.2259 13.4477 26.2259 14V34.9241C26.2259 35.4764 25.7782 35.9241 25.2259 35.9241H22.6411C22.0888 35.9241 21.6411 35.4764 21.6411 34.9241V14C21.6411 13.4477 22.0888 13 22.6411 13H25.2259Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5848 13C18.1371 13 18.5848 13.4477 18.5848 14V34.9241C18.5848 35.4764 18.1371 35.9241 17.5848 35.9241H15C14.4477 35.9241 14 35.4764 14 34.9241V14C14 13.4477 14.4477 13 15 13H17.5848Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2129_70",
    x1: 1.06167e-7,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplementaryPensionSavings);
export default __webpack_public_path__ + "static/media/SupplementaryPensionSavings.0112ffc5efabf56f2559784eb9a025f5.svg";
export { ForwardRef as ReactComponent };